import * as React from 'react'

import {
  FilterType,
  buildReviewsDataTableFilter,
  useReviewsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { StatusTag } from '../helpers/StatusTag'

export const statusFilter = (source: ReturnType<typeof useReviewsDataTable>) => {
  const options = [
    {
      label: i18n.t('surveys.index.table.filters.draft'),
      value: 'draft',
      component: <StatusTag status="draft" />,
    },
    {
      label: i18n.t('surveys.index.table.filters.active'),
      value: 'active',
      component: <StatusTag status="active" />,
    },
    {
      label: i18n.t('surveys.index.table.filters.scheduled'),
      value: 'scheduled',
      component: <StatusTag status="scheduled" />,
    },
    {
      label: i18n.t('surveys.index.table.filters.closed'),
      value: 'finished',
      component: <StatusTag status="finished" />,
    },
  ]

  return buildReviewsDataTableFilter(source, {
    type: FilterType.String,
    default: true,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
      {
        kind: 'SingleChoice',
        operation: 'notEq',
        options,
      },
    ],
    identifier: 'statusFilter',
    path: 'status',
    title: i18n.t('surveys.index.table.header.state'),
  })
}
